import React, { useCallback, useEffect } from "react";
import { scrollToElem } from 'cityads-v3/utils/htmlUtils';

export function useScrollToTop() {
  const scrollToTop = useCallback((elem: Element = null, offset = 0) => {
    const headerEl = window?.document.getElementById('header');

    scrollToElem(elem ?? window?.document.body, (headerEl ? -headerEl.offsetHeight : 0) + offset);
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  return scrollToTop;
}

export function usePressEnter<T = HTMLInputElement>(callback: (event: React.KeyboardEvent<T>) => void) {
  const handler = useCallback((event: React.KeyboardEvent<T>) => {
    if (event.key === 'Enter') {
      callback(event);
    }
  }, [callback])

  return handler;
}
